export default "__VITE_ASSET__HSccJ6Hc__"